import React, { useEffect, useMemo, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  Label,
  Input,
  Nav,
  NavItem,
  NavLink,
  Spinner,
} from "reactstrap";

import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import usePersistStoreData from "../../../Components/Hooks/usePersistStoreData";
import DocumentActionCard from "../../../Components/Common/DocumentActionCard";
import {
  ProfileDetailThunk,
  reKyc_EsignRequestThunk,
  reKyc_Esign_DocumentDownloadThunk,
  reKyc_digio_requestResponseThunk,
} from "../../../slices/thunks";
import CommonLoading from "../../../Components/Common/CommonLoading";
import { showToast } from "../../../Components/ToastNotification";

const AddMtf = () => {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const { userData } = usePersistStoreData();
  const token = userData?.token;
  const [loading, setLoading] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [isSigned, setIsSigned] = useState(false);
  const { reKyc_EsignRequestData, reKyc_EsignRequestLoading } = useSelector(
    (state) => state.Re_Kyc_Esign_Request
  );
  const {  reKyc_Esign_DocumentLoading } = useSelector(
    (state) => state.Re_Kyc_Digio_Request_Response
  );

  const handleDownloadDocument = () => {
    dispatch(
      reKyc_Esign_DocumentDownloadThunk({ params: { type: "mtf" }, token })
    )
      .unwrap()
      .then((result) => {
        const blob = new Blob([result], { type: "application/pdf" });

        const fileURL = window.URL.createObjectURL(blob);

        // Open in new tab
        window.open(fileURL, "_blank");

        // Also download
        const link = document.createElement("a");
        link.href = fileURL;
        link.download = "add_mtf.pdf"; // file name
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // showToast("Downloaded successfully", "success");
        navigate("/profile");
        setIsProcessing(false);
      })
      .catch((error) => {
        showToast(
          error?.message || "Something went wrong. Please try again later",
          "error"
        );
      });
  };

  // Open Digio popup with API response data
  const openDigioPopup = (digioData) => {
    if (!window.Digio) {
      // console.error("Digio SDK not loaded");
      showToast(
        "Digio SDK is not loaded. Please refresh the page and try again.",
        "error"
      );
      setIsProcessing(false);
      return;
    }
    try {
      // Digio configuration with callback
      const options = {
        environment: "production", // or "sandbox" for testing
        callback: function (response) {
          if (response.hasOwnProperty("error_code")) {
            // console.log("Error occurred in process:", response);
            // Handle error
            setIsProcessing(false);
            showToast(response?.message, "error");
            return;
          }
          handleDownloadDocument();
          // console.log("Signing completed successfully:", response);
          setIsSigned(true);
        },
        event_listener: function () {
          // Prevent Digio SDK from throwing when trying to call this
          // console.log("Digio event listener triggered");
          setIsProcessing(false);
        },
      };

      // Create new Digio instance
      const digio = new window.Digio(options);

      // Initialize Digio
      digio.init();

      digio.submit(
        digioData?.id, 
        digioData?.identifier);
    } catch (error) {
      console.error("Error opening Digio popup:", error);
      showToast("Error opening Digio: " + error.message, "error");
      setIsProcessing(false);
    }
  };

  const handleDigioRequest = () => {
   
    setIsProcessing(true);
    dispatch(reKyc_EsignRequestThunk({ params: { type: "mtf" }, token }))
      .then((res) => {
        if (res?.payload?.code === 200) {
          openDigioPopup(res?.payload?.data);
          setIsProcessing(false);
        } else {
          showToast(
            res?.error?.message || "Something went wrong, please try again",
            "error"
          );
          setIsProcessing(false);
        }
      })
      .catch((err) => {
        showToast(
          err?.message || "Something went wrong, please try again",
          "error"
        );
        setIsProcessing(false);
      });
  };

  
  useEffect(() => {
    setLoading(true);
    dispatch(ProfileDetailThunk(userData?.token))
      .then((res) => {
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {loading ? (
            <div
              className="centerContent h-100 w-100"
              style={{ minHeight: "80vh" }}
            >
              <CommonLoading />
            </div>
          ) : (
            <>
              <div className="position-relative mx-n4 mt-n4">
                <div
                  className="profile-wid-bg profile-setting-img"
                  style={{ backgroundColor: "#01256D" }}
                >
                  <div className="overlay-content">
                    <div className="text-end p-3">
                      <div className="p-0 ps-2 ms-auto rounded-circle profile-photo-edit">
                        <Nav
                          pills
                          className=" animation-nav profile-nav gap-2 gap-lg-3 flex-grow-1"
                          role="tablist"
                        >
                          <NavItem>
                            <NavLink
                              // className={classnames(" ", {
                              //   active: activeTab === "1",
                              // })}
                              onClick={() => {
                                navigate("/edit_option");
                              }}
                              style={{
                                backgroundColor: "transparent",
                                border: "1px solid #0FA67B",
                              }}
                            >
                              <svg
                                className="me-2"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M3.99 9L16 9L16 7L3.99 7L3.99 4L3.49691e-07 8L3.99 12L3.99 9Z"
                                  fill="#0FA67B"
                                />
                              </svg>
                              <span className="d-none d-md-inline-block">
                                Go Back
                              </span>
                            </NavLink>
                          </NavItem>
                        </Nav>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <Row>
                <Col xxl={12} xl={12}>
                  <Card className="mt-xxl-n5 mt-xl-n5">
                    <CardHeader>
                      <h5 className="card-title mb-0">Add MTF</h5>
                    </CardHeader>
                    <CardBody>
                      <Row className="row m-0 p-0">
                        <Col lg={6} className="mb-0 ps-0">
                          <div className="mb-3">
                            <Label
                              htmlFor="tradingCodeInput"
                              className="form-label"
                            >
                              Trading Code
                            </Label>

                            <Input
                              type="text"
                              className="form-control"
                              id="tradingCodeInput"
                              placeholder="Enter trading code"
                              defaultValue={userData?.trade?.short_code}
                              disabled
                            />
                          </div>
                        </Col>
                        <Col lg={6} className="mb-0 ps-0">
                          <div className="mb-3">
                            <Label
                              htmlFor="beneficiaryOwnerInput"
                              className="form-label"
                            >
                              Beneficiary Owner (BO ID)
                            </Label>

                            <Input
                              type="text"
                              className="form-control"
                              id="beneficiaryOwnerInput"
                              placeholder="Enter beneficiary owner (BO ID)"
                              defaultValue={`${userData?.trade?.dp_id}${userData?.trade?.dp_account_number}`}
                              disabled
                            />
                          </div>
                        </Col>
                        <Col lg={6} className="mb-0 ps-0">
                          <div className="mb-3">
                            <Label
                              htmlFor="phonenumberInput"
                              className="form-label"
                            >
                              Mobile Number
                            </Label>

                            <Input
                              type="text"
                              className="form-control"
                              id="phonenumberInput"
                              placeholder="Enter your mobile number"
                              defaultValue={`+91 ${userData?.personal_details?.mobile}`}
                              disabled
                            />
                          </div>
                        </Col>
                        <Col lg={6} className="mb-0 ps-0">
                          <div className="mb-3">
                            <Label
                              htmlFor="firstnameInput"
                              className="form-label"
                            >
                              Client Name
                            </Label>

                            <Input
                              type="text"
                              className="form-control"
                              id="firstnameInput"
                              placeholder="Enter client name"
                              defaultValue={userData?.name}
                              disabled
                            />
                          </div>
                        </Col>
                        <Col lg={6} className="mb-0 ps-0">
                          <div className="mb-3">
                            <Label htmlFor="email" className="form-label">
                              Email ID
                            </Label>

                            <Input
                              type="text"
                              className="form-control"
                              id="email"
                              placeholder="Enter your email address"
                              defaultValue={userData?.personal_details?.email}
                              disabled
                            />
                          </div>
                        </Col>
                        <Col lg={6} className="mb-0 ps-0">
                          <div className="mb-3">
                            <Label htmlFor="Address" className="form-label">
                              Address Line
                            </Label>
                            <Input
                              type="textarea"
                              className="form-control"
                              id="Address"
                              placeholder="Enter your Address"
                              defaultValue={`${userData?.personal_details?.address?.line_one}, ${userData?.personal_details?.address?.line_two}, ${userData?.personal_details?.address?.line_three}, ${userData?.personal_details?.address?.line_four}`}
                              disabled
                            />
                          </div>
                        </Col>

                        <div className="d-flex align-items-center justify-content-between ps-0 flex-wrap ">
                          <p className="mb-0 fs-14 text-muted fw-medium">
                            <span
                              className=""
                              style={{
                                color: "#f06548",
                              }}
                            >
                              *
                            </span>{" "}
                            If desired to change the above information, complete
                            your rekyc first
                          </p>
                          <button
                              type="button"
                              className="btn btn-primary  fs-14"
                              onClick={handleDigioRequest}
                              style={{ minWidth: "160px" }}
                              disabled={
                                reKyc_EsignRequestLoading || isProcessing || reKyc_Esign_DocumentLoading
                              }
                            >
                              {!reKyc_EsignRequestLoading || 
                                (!reKyc_EsignRequestLoading && (
                                  <i className="mdi mdi-file-document-outline me-2 fs-16"></i>
                                ))}

                              {reKyc_EsignRequestLoading || isProcessing || reKyc_Esign_DocumentLoading? (
                                <Spinner size="sm" />
                              ) : (
                                "Proceed to e-Sign"
                              )}
                            </button>

                          {/* {isSigned ? (
                            <button
                              type="button"
                              className="btn btn-primary btn-sm fs-14"
                              onClick={handleDownloadDocument}
                              style={{ minWidth: "160px" }}
                              disabled={reKyc_Esign_DocumentLoading}
                            >
                              {!reKyc_Esign_DocumentLoading && (
                                <i className="mdi mdi-file-document-outline me-2 fs-16"></i>
                              )}
                              {reKyc_Esign_DocumentLoading ? (
                                <Spinner size="sm" />
                              ) : (
                                "Download E-Sign Document"
                              )}
                            </button>
                          ) : (
                            <button
                              type="button"
                              className="btn btn-primary btn-sm fs-14"
                              onClick={handleDigioRequest}
                              style={{ minWidth: "160px" }}
                              disabled={
                                reKyc_EsignRequestLoading || isProcessing
                              }
                            >
                              {!reKyc_EsignRequestLoading ||
                                (!reKyc_EsignRequestLoading && (
                                  <i className="mdi mdi-file-document-outline me-2 fs-16"></i>
                                ))}

                              {reKyc_EsignRequestLoading || isProcessing ? (
                                <Spinner size="sm" />
                              ) : (
                                "Proceed to e-Sign"
                              )}
                            </button>
                          )} */}
                        </div>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default AddMtf;
